import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const ProductPriceDisplay = ({ data }) => {
  return (
    <div className="container mt-1">
      {data.camps.map((camp) => (
        <div className="card mb-4" key={camp.campId}>
          <div className="rounded-pill card-header bkg-primary text-white d-flex justify-content-between">
            <h6 className="mb-0 text-white">{camp.campName}</h6>
            <small>
              Processing Fees: {camp?.paymentRate?.percentage ?? 0}%
              {camp?.paymentRate?.taxRate > 0 && ` + $${camp?.paymentRate?.taxRate}`}
            </small>
          </div>

          <div className="card-body">
            {camp.bookings.map((booking) => (
              <div className="mt-3" key={booking.bookingId}>
                <table className="table table-bordered mt-2">
                  <colgroup>
                    <col />
                    <col style={{ width: '70px' }} />
                    <col style={{ width: '80px' }} />
                  </colgroup>
                  <thead className="table-light">
                    <tr>
                      <th>Description</th>
                      <th>Count</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {booking.itemData.map((item) => (
                      <React.Fragment key={item.itemId}>
                        <tr>
                          <td>
                            {item.title}
                            <div className="mt-1">
                              <small className="rounded-pill bkg-primary text-white p-1">
                                {item.programName} - {item.bookingNumber} - {item.camperName}
                              </small>
                            </div>
                          </td>
                          <td><strong>{item.count}</strong></td>
                          <td>${item.price}</td>
                        </tr>

                        {/* Add-ons if present */}
                        {item?.subItems?.length > 0 && (
                          <tr className="ml-2">
                            <td colSpan="3" className="bg-light">
                              <small><strong>Addons:</strong></small>
                              <table className="table table-bordered mt-2 table-sm mt-1 mb-0">
                                <tbody>
                                  {item.subItems.map((sub, idx) => (
                                    <tr key={idx}>
                                      <td><small>{sub.title}</small></td>
                                      <td style={{ width: '72px' }}><small>{sub.count}</small></td>
                                      <td style={{ width: '82px' }}><small>${sub.price}</small></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}

            <div className="d-flex justify-content-end mt-3">
              <div>
                <p className="mb-1"><strong>Processing Fees:</strong> ${camp.applicationFeeAmount.toFixed(2)}</p>
                <p className="mb-0"><strong>Total Camp Amount:</strong> ${camp.amount.toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="alert alert-success text-end fw-bold">
        Total Payable Amount: ${data.payableAmount.toFixed(2)}
      </div>
    </div>
  );
};

export default ProductPriceDisplay;